<template>
    <transition name="fade">
        <div
            v-if="show"
            class="d-search"
        >
            <main>
                <label
                    for="searchBox"
                    class="search-box"
                >
                    <DIcon name="magnify" />
                    <input
                        id="searchBox"
                        ref="search"
                        v-model="searchQuery"
                        autocomplete="off"
                        type="text"
                        @focus="select"
                    >
                    <label class="exact-results-switch">
                        <DSwitch
                            v-model="isExactResultsOnly"
                            color="success"
                            variant="3d"
                            @update:checked="toggleExactResults"
                        />
                        <span>{{ __('messages.searchbox.modal.exact_results_only') }}</span>
                    </label>
                    <DButton
                        mini
                        icon="close"
                        @click="hideOverlay"
                    />
                </label>
                <div>
                    <div
                        v-show="state === 'results'"
                        class="search-tabs"
                    >
                        <div
                            v-for="(tab, key) in tabs"
                            :key="key"
                            class="tab"
                            :class="{'active' : filteredType === tab}"
                            @click="filterType(tab)"
                        >
                            {{ __(`messages.searchbox.tabs.${tab}`) }}
                        </div>
                    </div>
                </div>
                <section class="search-results">
                    <div
                        v-if="state === 'results'"
                        class="items"
                    >
                        <section
                            v-for="(result, index) in results"
                            :key="index"
                        >
                            <header
                                v-if="result.length > 0 && filteredType === 'all'"
                            >
                                {{ index }}
                            </header>
                            <div
                                v-for="(item, key) in result"
                                :key="item.id"
                                class="results"
                            >
                                <Link
                                    v-if="index === `customers` && ['all', 'customers'].includes(filteredType)"
                                    :href="resultUrl('customers.customers.show', {customer: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultCustomer
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `contacts` && ['all', 'contacts'].includes(filteredType)"
                                    :href="resultUrl('customers.customers.contacts.show', {customer: item.customer_id, contact: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultContact
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `contracts` && ['all', 'contracts'].includes(filteredType)"
                                    :href="resultUrl('customers.customers.contracts.index', {customer: item.customer_id, contract: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultContract
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `products` && ['all', 'products'].includes(filteredType)"
                                    :href="resultUrl('products.products.show', {product: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultProduct
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `invoices` && ['all', 'invoices'].includes(filteredType)"
                                    :href="resultUrl('customers.customers.invoices.show', {customer: item.customer_id, invoice: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultInvoice
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `credit_notes` && ['all', 'credit_notes'].includes(filteredType)"
                                    :href="resultUrl('customers.customers.credit-notes.show', {customer: item.customer_id, credit_note: item.id})"
                                    target="_blank"
                                >
                                    <SearchResultCreditNote
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>

                                <Link
                                    v-if="index === `orders` && ['all', 'orders'].includes(filteredType)"
                                    :href="resultUrl('orders.details', orderDetailsRouteParams(item))"
                                    target="_blank"
                                >
                                    <SearchResultOrder
                                        :id="passId(index, key)"
                                        :data="item"
                                        :active-id="activeId"
                                        @click="openResultPage"
                                    />
                                </Link>
                            </div>
                        </section>
                    </div>
                    <div
                        v-if="state === 'initial'"
                        class="text"
                    >
                        <div class="content">
                            <span class="mdi mdi-database-search" />
                            <p>{{ __('messages.searchbox.messages.initial') }}</p>
                        </div>
                    </div>
                    <div
                        v-if="state === 'noresults'"
                        class="text"
                    >
                        <div class="content">
                            <span class="mdi mdi-database-off" />
                            <p>{{ __('messages.searchbox.messages.noresults') }}</p>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    </transition>
</template>

<script>

import _ from 'lodash'
import SearchResultCustomer from './SearchResultCustomer'
import SearchResultContact from './SearchResultContact'
import SearchResultProduct from './SearchResultProduct'
import SearchResultInvoice from './SearchResultInvoice'
import SearchResultCreditNote from './SearchResultCreditNote'
import SearchResultContract from './SearchResultContract'
import SearchResultOrder from '~@/Components/Search/SearchResultOrder.vue'
import orderNumber from '~@/Mixins/orderNumber'

export default {
    name: 'DSearch',
    components: {
        SearchResultOrder,
        SearchResultContract,
        SearchResultProduct,
        SearchResultContact,
        SearchResultCustomer,
        SearchResultInvoice,
        SearchResultCreditNote
    },
    mixins: [orderNumber],
    data () {
        return {
            state: 'initial',
            show: false,
            results: null,
            filteredType: 'all',
            activeTab: 0,
            searchQuery: '',
            isExactResultsOnly: true,
            tabs: ['all', 'customers', 'contacts', 'contracts', 'products', 'invoices', 'credit_notes', 'orders'],
            activeId: 0,
            maxResults: 0,
            searchQueryState: ''
        }
    },
    watch: {
        searchQuery: _.debounce(function (value) {
            this.search(value, this.isExactResultsOnly)
        }, 300)
    },
    created () {
        window.addEventListener('keydown', this.handleKeys)
        this.emitter.on('search', (query) => {
            this.searchQuery = query
            this.showOverlay()
        })
    },
    unmounted () {
        window.removeEventListener('keydown', this.handleKeys)
    },
    methods: {
        toggleExactResults (result) {
            this.search(this.searchQuery, result)
        },
        async search (query, isExact) {
            this.results = null
            this.state = 'initial'
            if (this.searchQuery.length > 0) {
                let resultsCount = ''
                if (isExact === true) {
                    query = '"' + query + '"'
                }
                const response = await window.axios.get(this.$route('search.show', { search: query }))
                this.results = response.data
                this.maxResults = this.countResults()
                this.filterType('all')
                resultsCount = this.countResults()
                if (resultsCount < 1) {
                    this.state = 'noresults'
                } else {
                    this.state = 'results'
                }
            }
        },
        handleKeys (event) {
            // CTRL + SPACE on Windows
            // Control  + SPACE on Mac OS
            if (event.code && event.code.toLowerCase() === 'space' && event.ctrlKey) {
                event.preventDefault()

                this.showOverlay()
            }

            // ESC Key
            if (event.keyCode === 27) {
                this.hideOverlay()
            }

            // If modal is not open don't react to arrow / tab keys
            if (this.show === false) {
                return
            }

            // UP - UP key
            if (event.code === 'ArrowUp' && this.activeId > 0) {
                this.activeId -= 1
            }
            // DOWN - DOWN key
            if (event.code === 'ArrowDown' && this.activeId < (this.maxResults - 1)) {
                this.activeId += 1
            }

            // TAB
            if (event.code === 'Tab' && !event.shiftKey && this.activeTab < (this.tabs.length - 1)) {
                this.filterType(this.tabs[this.activeTab], 'tab')
            }

            // SHIFT TAB
            if (event.shiftKey && event.code === 'Tab' && this.activeTab > 0) {
                this.filterType(this.tabs[this.activeTab], 'shift-tab')
            }
        },
        filterType (type, tab = '') {
            this.activeId = 0
            if (tab === 'tab') {
                this.activeTab = this.tabs.indexOf(type) + 1
            }
            if (tab === 'shift-tab') {
                this.activeTab = this.tabs.indexOf(type) - 1
            }
            if (tab === '') {
                this.activeTab = this.tabs.indexOf(type)
            }
            this.filteredType = this.tabs[this.activeTab]
            if (this.activeTab === 0) {
                this.maxResults = this.countResults()
            } else {
                this.maxResults = this.results[this.tabs[this.activeTab]].length
            }
        },
        showOverlay () {
            this.searchQuery = this.searchQueryState
            this.show = true
            this.$nextTick(() => this.$refs.search.focus())
        },
        hideOverlay () {
            this.searchQueryState = this.searchQuery
            this.show = false
        },
        select () {
            this.$refs.search.select()
        },
        openResultPage (resultUrl) {
            this.show = false
            this.$inertia.get(resultUrl)
        },
        resultUrl (route, data) {
            return this.$route(route, data)
        },
        countResults () {
            const resultCount = (resultSet) => resultSet ? resultSet.length : 0

            return resultCount(this.results.customers) +
                resultCount(this.results.contacts) +
                resultCount(this.results.contracts) +
                resultCount(this.results.invoices) +
                resultCount(this.results.credit_notes) +
                resultCount(this.results.products) +
                resultCount(this.results.orders)
        },
        passId (index, key) {
            if (this.activeTab > 0) {
                return key
            }
            return this.uniqueId(index, key)
        },
        uniqueId (item, key) {
            switch (item) {
                case 'customers':
                    return key
                case 'contacts':
                    return key +
                    this.results.customers.length
                case 'contracts':
                    return key +
                    this.results.customers.length +
                    this.results.contacts.length
                case 'products':
                    return key +
                    this.results.customers.length +
                    this.results.contacts.length +
                    this.results.contracts.length
                case 'invoices':
                    return key +
                    this.results.customers.length +
                    this.results.contacts.length +
                    this.results.contracts.length +
                    this.results.products.length
                case 'credit_notes':
                    return key +
                    this.results.customers.length +
                    this.results.contacts.length +
                    this.results.contracts.length +
                    this.results.products.length +
                    this.results.invoices.length
                case 'orders':
                    return key +
                        this.results.customers.length +
                        this.results.contacts.length +
                        this.results.contracts.length +
                        this.results.products.length +
                        this.results.invoices.length +
                        this.results.credit_notes.length
                default:
                    return key
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.d-search {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 30px;

    & main {
        max-height: calc(100vh - 100px);
        min-height: 400px;
        background :#fff;
        width: 800px;
        display: grid;
        grid-template-rows: auto auto 1fr;
        border-radius: 5px;
        overflow-x: auto;

        & .search-box {
            display: grid;
            grid-template-columns: auto 1fr auto auto;
            border-bottom: 1px solid rgba(0,0,0,0.14);
            grid-gap: 15px;
            align-items: center;
            padding: 7px 7px 7px 15px;
            cursor: text;

            & .exact-results-switch {
                display: flex;
                align-items: center;
                grid-gap: 10px;
                align-self: center;
                margin: 0;
            }
            & input {
                border: 0;
                width: 100%;
                padding: 10px;

                &:focus {
                    outline: none;
                }
            }
        }
        & .search-tabs {
            display: flex;
            border-bottom: 1px solid rgba(0,0,0,0.14);

            & .tab {
                padding: 12px 15px;
                font-size: 16px;
                border-bottom: 3px solid transparent;
                cursor: pointer;

                &.active {
                    border-color: var(--colorPrimary);
                }
            }
        }
        & .search-results {
            overflow-y: scroll;
            display: flex;
            flex-direction: column;

            & .items {
                & > section {
                    & header {
                        font-size: 12px;
                        font-weight: bold;
                        letter-spacing: 0.15em;
                        text-transform: uppercase;
                        padding: 15px 25px 10px;
                        background: rgba(0, 0, 0, 0.07);
                    }

                    & .results {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                }
            }
            & .content {
                height: 300px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;
                flex-direction: column;

                & .mdi {
                    width: 64px;
                    height: 64px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 64px;
                    color: var(--colorPrimary);
                }
                & p {
                    color: var(--colorPrimaryText);
                    max-width: 380px;
                    line-height: 1.5em;
                    text-align: center;
                }
            }
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
